const guidesData = [
  // ============ FREE GUIDES ============
  {
    img: "/images/jsToReactLogo.webp",
    title: "From JavaScript to React: Your First Steps",
    desc: "The essential bridge for JavaScript developers entering React. Refresh the JS patterns React relies on, see why React improves on vanilla JS, set up your environment, write your first components with JSX, and complete a mini build to solidify the concepts — everything you need to confidently start building with React.",
    to: "/guides/jstoreact",
    isPremium: false,
  },
  {
    img: "/images/rectIntroLogo.webp",
    title: "Introduction to React Programming",
    desc: "Embark on a cosmic journey through React's universe. Master JSX, Hooks, state management, routing, data fetching, performance, and more to build dynamic, scalable apps, with a roadmap to MERN mastery.",
    to: "/guides/reactintro",
    isPremium: false,
  },
  {
    img: "/images/componentsPropsLogo.webp",
    title: "Master React Components & Props",
    desc: "The definitive guide to React's core building blocks. Build reusable, composable components from basics to production patterns, mastering props, composition, conditional rendering, lists, callbacks, and real-world examples — everything you need to create scalable React UIs.",
    to: "/guides/componentsprops",
    isPremium: false,
  },
  {
    img: "/images/reactTodoLogo.webp",
    title: "Build a React Todo App",
    desc: "The perfect starting point for absolute beginners. Build a complete Todo app from scratch while learning components, state, props, and event handling — everything you need to write your first React application.",
    to: "/guides/reacttodo",
    isPremium: false,
  },
    {
    img: "/images/useStateLogoCard.webp",
    title: "Understanding useState",
    desc: "Master the useState hook in React to manage component state efficiently. Learn how to declare state variables, update values dynamically, and use state effectively to build interactive UIs.",
    to: "/guides/usestate",
    isPremium: false,
  },
  {
    img: "/images/useeffectLogo.webp",
    title: "Understanding useEffect",
    desc: "Learn how the useEffect hook lets you perform side effects in function components. Understand dependencies, cleanups, and how to control when effects run for optimal app performance.",
    to: "/guides/useeffect",
    isPremium: false,
  },

  // ============ PREMIUM GUIDES ============

  {
    img: "/images/stateeffectLogo.webp",
    title: "Mastering useState + useEffect",
    desc: "Learn how to combine useState and useEffect Hooks to manage both state and side effects seamlessly in your React applications. Explore real-world examples and best practices for building dynamic, responsive UIs.",
    to: "/guides/stateeffect",
    isPremium: true,
  },
  {
    img: "/images/reactFormsLogo.webp",
    title: "Master React Forms",
    desc: "The essential guide for handling forms in React. Build complete, validated forms from basics to advanced patterns, mastering controlled inputs, multiple fields, validation, various input types, and real-world examples — everything you need to create robust React applications.",
    to: "/guides/reactforms",
    isPremium: true,
  },
  {
    img: "/images/useContextLogo.webp",
    title: "Mastering useContext",
    desc: "The definitive guide to React's useContext Hook. Learn to manage global state effortlessly, avoid prop drilling, and implement advanced patterns with this comprehensive tutorial covering all skill levels from beginner to expert.",
    to: "/guides/usecontext",
    isPremium: true,
  },
  {
    img: "/images/reactTodoPart2Logo.webp",
    title: "Build a React Todo App - Part 2",
    desc: "Elevate your beginner React app with advanced features. Add delete and toggle functionality, professional CSS styling, localStorage persistence, avoid common pitfalls, and split into reusable components with props — everything you need to build polished, maintainable React applications.",
    to: "/guides/reacttodo2",
    isPremium: true,
  },
  {
    img: "/images/useReducerLogo.webp",
    title: "Getting Started with useReducer",
    desc: "Dive into the useReducer hook to handle complex state logic in React. Learn how it complements useState, when to use it, and how to build scalable and predictable state management solutions.",
    to: "/guides/usereducer",
    isPremium: true,
  },
  {
    img: "/images/customHooksLogo.webp",
    title: "Master React Custom Hooks",
    desc: "The definitive guide to creating and using custom hooks in React. Extract reusable logic from useState, useEffect, useReducer, and more through 7 progressive examples, mastering rules, pitfalls, and composition — everything you need to build clean, scalable React applications.",
    to: "/guides/customhooks",
    isPremium: true,
  },
  {
    img: "/images/reactrouterLogo.webp",
    title: "React Router Fundamentals",
    desc: "Learn how to implement navigation and dynamic routing in React using React Router. This guide covers everything from basic route setup to nested routes, route parameters, and protected routes.",
    to: "/guides/reactrouter",
    isPremium: true,
  },
  {
    img: "/images/dataFetchingLogo.webp",
    title: "Data Fetching in React",
    desc: "Explore techniques to fetch data in React applications using hooks like useEffect and libraries like Axios and React Query. Learn best practices for loading states, error handling, and optimizing network requests.",
    to: "/guides/datafetching",
    isPremium: true,
  },
  {
    img: "/images/reactPerformanceLogo.webp",
    title: "React Performance Optimisation",
    desc: "Master React's three performance tools — React.memo, useMemo, and useCallback. Learn when re-renders are a problem, how to measure them, and how to fix them through progressive examples from render visualisation to a full app performance audit.",
    to: "/guides/reactoptimisation",
    isPremium: true,
  },
  {
    img: "/images/reactStateManagementLogo.webp",
    title: "Master React State Management",
    desc: "The ultimate guide to managing state in React. Explore local, shared, global, and server state through theory, a decision framework, comparisons, and 7 progressive examples building the same app with different approaches — everything you need to choose and implement the right state solution.",
    to: "/guides/reactstatemanagement",
    isPremium: true,
  },
  {
    img: "/images/mernStackLogo.webp",
    title: "Master MERN Stack Development",
    desc: "The comprehensive guide to full-stack MERN applications. Build Express APIs, connect React frontends, implement CRUD with MongoDB, add JWT authentication, handle file uploads, and create a complete app — everything you need to develop robust web applications from frontend to backend.",
    to: "/guides/mernstack",
    isPremium: true,
  },
];

export { guidesData };